"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const NOTIFICATION_UPDATE_INTERVAL = 60 * 1000; //ping every minute
const LAST_CLOSED_NOTIFICATION_KEY = "lastclosednotificationkey";
const Popup = (props) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [content, setContent] = (0, react_1.useState)();
    const [response, setResponse] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const apiPinger = setInterval(function () {
            fetchData();
        }, NOTIFICATION_UPDATE_INTERVAL);
        fetchData();
        return () => clearInterval(apiPinger);
    }, []);
    (0, react_1.useEffect)(() => {
        if (response && response.length > 0) {
            const lastItem = response[response.length - 1];
            if (isLatestClosed(lastItem)) {
                setOpen(false);
                return;
            }
            const areEqual = (content === null || content === void 0 ? void 0 : content.id) === lastItem.id && content.publishTimestamp === lastItem.publishTimestamp;
            if (!areEqual) {
                setContent(lastItem);
                setOpen(false);
                setTimeout(() => {
                    setOpen(true);
                }, 1000);
            }
        }
        else {
            setOpen(false);
        }
    }, [response, content]);
    function fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(props.endpointUrl);
            if (response.status !== 200) {
                console.warn("something went wrong");
                return;
            }
            const notifications = yield response.json();
            setResponse(notifications);
        });
    }
    function closeMessage(content) {
        addToLocalStorage(LAST_CLOSED_NOTIFICATION_KEY, {
            id: content.id,
            timestamp: content.publishTimestamp,
        });
        setOpen(false);
    }
    function isLatestClosed(content) {
        const currentLastClosed = getFromLocalStorage(LAST_CLOSED_NOTIFICATION_KEY);
        if (currentLastClosed &&
            currentLastClosed.id === content.id &&
            currentLastClosed.timestamp === content.publishTimestamp) {
            return true;
        }
        return false;
    }
    function addToLocalStorage(key, notification) {
        const jsonString = JSON.stringify(notification);
        localStorage.setItem(key, jsonString);
    }
    function getFromLocalStorage(key) {
        const localStorageContent = localStorage.getItem(key);
        if (localStorageContent === null)
            return null;
        const storedData = JSON.parse(localStorageContent);
        return storedData;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: `popup ${open ? "popup-active" : ""}`, children: (0, jsx_runtime_1.jsxs)("div", { className: "popup__content", children: [(0, jsx_runtime_1.jsxs)("div", { className: "popup__info", children: [(0, jsx_runtime_1.jsx)("div", { className: "popup__heading", children: content && content.title }), (0, jsx_runtime_1.jsx)("div", { children: ((content === null || content === void 0 ? void 0 : content.isFirstPublish) && "Ny artikkel") || "Ny oppdatering" }), content && content.url && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: content.url, children: "Les mer" }) }))] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", { className: "popup__btn-close", onClick: () => {
                            closeMessage(content);
                        }, "aria-label": "Lukk melding", children: "Lukk" }) })] }) }));
};
const initPopup = () => {
    const nodeId = "popup-root";
    const appRootNode = document.getElementById(nodeId);
    if (!appRootNode) {
        console.warn(`Cannot find node with ID '${nodeId}'. The React app cannot be rendered.`);
        return;
    }
    const endpointUrl = appRootNode === null || appRootNode === void 0 ? void 0 : appRootNode.getAttribute("data-react-props");
    if (!endpointUrl) {
        console.warn(`missing props for '${nodeId}'. The react app cannot be rendered.`);
        return;
    }
    (0, client_1.createRoot)(appRootNode).render(react_1.default.createElement(Popup, {
        endpointUrl: endpointUrl,
    }));
};
initPopup();
